import React, { useContext, useEffect, useState } from "react";
import { Button, Select, Input, Radio, message } from "antd";
import { UserContext } from "../../context/userContext";
import { getProductsDetails } from "../../services/productsDetails/productsDetails";
import { getHeaderByProductId } from "../../services/headersProducts/headersProducts";
import { priceNew } from "../../helper/priceNew";
import { formatNumber } from "../../helper/fomartNum";
import "./CheckoutCart.scss";
import {
  patchStockProduct,
  postOrders,
  updateProductStock,
} from "../../services/checkout/checkout";
import { patchUserCart } from "../../services/user/user";
import { Link } from "react-router-dom";

const shippingFees = {
  "Thành phố Hồ Chí Minh": 20000,
  "Thành phố Hà Nội": 25000,
  "Tỉnh Đà Nẵng": 18000,
  default: 30000,
};

const CheckoutCart = () => {
  const { currentUser, setCurrentUser } = useContext(UserContext);

  const [cartProducts, setCartProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isPaid, setIsPaid] = useState(false);

  const [province, setProvince] = useState(null);
  const [district, setDistrict] = useState(null);
  const [ward, setWard] = useState(null);

  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [wardList, setWardList] = useState([]);

  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("cod");

  const [messageApi, contextHolder] = message.useMessage();

  // ================== LOAD DANH SÁCH TỈNH ==================
  useEffect(() => {
    fetch("https://provinces.open-api.vn/api/p/")
      .then((res) => res.json())
      .then((data) => setProvinceList(data))
      .catch(() => messageApi.error("Không tải được tỉnh/thành"));
  }, []);

  // ================== LOAD GIỎ HÀNG ==================
  useEffect(() => {
    if (!currentUser?.cart || currentUser.cart.length === 0) {
      setCartProducts([]);
      return;
    }

    const fetchCart = async () => {
      try {
        const results = await Promise.all(
          currentUser.cart.map((id) => getProductsDetails(id))
        );
        setCartProducts(results.map((r) => r[0]));
      } catch (err) {
        console.error(err);
        messageApi.error("Không tải được giỏ hàng");
      }
    };

    fetchCart();
  }, [currentUser]);

  if (!currentUser) return <div className="checkout">{contextHolder}</div>;

  // ================== CHỌN TỈNH ==================
  const handleProvinceChange = (value, option) => {
    const code = option.code;
    const name = option.label;

    setProvince({ code, label: name });
    setDistrict(null);
    setWard(null);
    setDistrictList([]);
    setWardList([]);

    fetch(`https://provinces.open-api.vn/api/p/${code}?depth=2`)
      .then((res) => res.json())
      .then((data) => setDistrictList(data.districts || []))
      .catch(() => messageApi.error("Không tải được quận/huyện"));
  };

  // ================== CHỌN QUẬN ==================
  const handleDistrictChange = (value, option) => {
    const code = option.code;
    const name = option.label;

    setDistrict({ code, label: name });
    setWard(null);
    setWardList([]);

    fetch(`https://provinces.open-api.vn/api/d/${code}?depth=2`)
      .then((res) => res.json())
      .then((data) => setWardList(data.wards || []))
      .catch(() => messageApi.error("Không tải được phường/xã"));
  };

  // ================== XÓA SẢN PHẨM ==================
  const handleRemove = async (id) => {
    try {
      const newCart = currentUser.cart.filter((pid) => pid !== id);
      await patchUserCart(currentUser.id, newCart); // đồng bộ backend
      setCurrentUser({ ...currentUser, cart: newCart });
      setCartProducts(cartProducts.filter((p) => p.id !== id));
      messageApi.success("Đã xóa sản phẩm khỏi giỏ");
    } catch (err) {
      console.error(err);
      messageApi.error("Xóa sản phẩm thất bại, thử lại sau");
    }
  };

  // ================== TỔNG TIỀN ==================
  const productTotal =
    cartProducts?.reduce((acc, p) => acc + priceNew(p.price_old, p.sales), 0) ||
    0;

  const shippingFee = province?.label
    ? shippingFees[province.label] || shippingFees.default
    : 0;

  const total = productTotal + shippingFee;

  // ================== ĐẶT HÀNG ==================
  const handleSubmit = async () => {
    if (!province || !district || !ward || !address || !phone) {
      messageApi.error("Vui lòng điền đầy đủ thông tin");
      return;
    }

    if (cartProducts.length === 0) {
      messageApi.error("Giỏ hàng trống");
      return;
    }

    setLoading(true);

    try {
      await postOrders({
        products: cartProducts,
        total,
        shipping: shippingFee,
        address: `${address}, ${ward.label}, ${district.label}, ${province.label}`,
        phone,
        paymentMethod,
        status: "Chờ xác nhận",
        userId: currentUser.id,
        createdAt: new Date().toISOString(),
      });

      for (const p of cartProducts) {
        await updateProductStock(p.idProducts, false);
        const header = await getHeaderByProductId(p.idProducts);
        await patchStockProduct(header.key, p.idProducts, false);
      }

      // Xóa giỏ hàng trên backend
      await patchUserCart(currentUser.id, []);
      setCurrentUser({ ...currentUser, cart: [] });
      setCartProducts([]);
      setIsPaid(true);

      messageApi.success("Đặt hàng thành công!");
    } catch (error) {
      console.error(error);
      messageApi.error("Có lỗi khi đặt hàng");
    }

    setLoading(false);
  };

  return (
    <div className="checkoutCart">
      {contextHolder}

      {isPaid ? (
        <div className="checkout-success">
          <h3>✅ Cảm ơn bạn đã đặt hàng.</h3>
          <p>Chúng tôi sẽ giao hàng sớm nhất.</p>
          <Link to="/">
            <Button className="btn-home">Về trang chủ</Button>
          </Link>
        </div>
      ) : (
        <>
          <h2>Thanh toán giỏ hàng</h2>

          {cartProducts.length === 0 ? (
            <div className="empty-cart">Giỏ hàng trống</div>
          ) : (
            cartProducts.map((p) => (
              <div key={p.id} className="checkoutCart-product">
                <img src={p.thumbnail1} alt={p.title} />
                <div className="info">
                  <div className="name">{p.title}</div>
                  <div className="size">Size: {p.size}</div>
                  <div className="price">
                    Giá:{" "}
                    <span className="price-new">
                      {formatNumber(priceNew(p.price_old, p.sales))}đ
                    </span>
                  </div>

                  <Button danger onClick={() => handleRemove(p.id)}>
                    Xóa
                  </Button>
                </div>
              </div>
            ))
          )}

          <div className="checkoutCart-form">
            <Input
              variant="borderless"
              placeholder="Số điện thoại"
              value={phone}
              className="checkoutCart-input-phone"
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
              maxLength={10}
            />

            <Select
              placeholder="Tỉnh / Thành phố"
              value={province}
              variant="borderless"
              className="checkoutCart-select-city"
              onChange={handleProvinceChange}
              options={provinceList.map((p) => ({
                value: p.code,
                label: p.name,
                code: p.code,
              }))}
            />

            <Select
              placeholder="Quận / Huyện"
              value={district}
              variant="borderless"
              className="checkoutCart-select-city"
              disabled={!province}
              onChange={handleDistrictChange}
              options={districtList.map((d) => ({
                value: d.code,
                label: d.name,
                code: d.code,
              }))}
            />

            <Select
              placeholder="Phường / Xã"
              value={ward}
              variant="borderless"
              className="checkoutCart-select-city"
              disabled={!district}
              onChange={(value, option) =>
                setWard({ code: option.code, label: option.label })
              }
              options={wardList.map((w) => ({
                value: w.code,
                label: w.name,
                code: w.code,
              }))}
            />

            <Input
              placeholder="Địa chỉ chi tiết"
              value={address}
              variant="borderless"
              className="checkoutCart-input-phone"
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          {/* ================= PAYMENT ================= */}
          <div className="payment-section">
            <h3>Phương thức thanh toán</h3>
            <Radio.Group
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <Radio value="cod">COD</Radio>
              <Radio value="momo" disabled>
                Momo
              </Radio>
              <Radio value="bank" disabled>
                Bank
              </Radio>
            </Radio.Group>
          </div>

          <div className="checkout-total">
            <div className="line">
              <span>Tạm tính:</span>
              <span className="money">{formatNumber(productTotal)}đ</span>
            </div>
            <div className="line">
              <span>Phí ship:</span>
              <span className="money">{formatNumber(shippingFee)}đ</span>
            </div>
            <div className="line total">
              <span>Tổng:</span>
              <span className="money">{formatNumber(total)}đ</span>
            </div>
          </div>

          <Button
            className="checkoutCart-btn-by"
            loading={loading}
            onClick={handleSubmit}
          >
            Xác nhận thanh toán
          </Button>
        </>
      )}
    </div>
  );
};

export default CheckoutCart;
